import { render, staticRenderFns } from "./hj1.vue?vue&type=template&id=201e212f&scoped=true"
import script from "./hj1.vue?vue&type=script&lang=js"
export * from "./hj1.vue?vue&type=script&lang=js"
import style0 from "./hj1.vue?vue&type=style&index=0&id=201e212f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201e212f",
  null
  
)

export default component.exports